import { render, staticRenderFns } from "./proSearch.vue?vue&type=template&id=beb72242&"
import script from "./proSearch.vue?vue&type=script&lang=js&"
export * from "./proSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports